module.exports = __webpack_public_path__ + "img/Réalisation portail avec découpe laser pour ressemblance avec cloture béton existante.14f1eaaf.jpg";